module.exports = __webpack_public_path__ + "img/main-logo.430c9daa.svg";